var InvoiceJs = (function ($) {

    var addFocusLossCompanyInput = function (companyInputSel, ninSectionSel, companySectionSel) {
        $(companyInputSel).on("focusout", function() {
            setInitialStatus(companyInputSel, ninSectionSel, companySectionSel);
        });
        setInitialStatus(companyInputSel, ninSectionSel, companySectionSel);
    };

    function setInitialStatus(companyInputSel, ninSectionSel, companySectionSel) {
        if (!($(companyInputSel).val())) {
            $(ninSectionSel).show();
            $(companySectionSel).hide();
        } else {
            $(companySectionSel).show();
            $(ninSectionSel).hide();
        }
    }

    var changeRequiredOnInvoiceCheck = function (invoiceSel, nidSectionSel) {
        $(invoiceSel).on("change", function() {
            if (this.checked) {
                $(nidSectionSel).addClass("checkout-required-field");
            } else {
                $(nidSectionSel).removeClass("checkout-required-field");
            }
        });
    };

    var addLegalEntitySelector = function(entityTypeSel, legalEntityInfoSel) {
        if(!$(entityTypeSel).length) {
            return;
        }
        if (!$(legalEntityInfoSel).length) {
            return;
        }

        $(entityTypeSel).on("click", function(event) {
            if ($(this).prop("checked") === true) {
                $(legalEntityInfoSel).show();
                $(".personal-data .j-company-info + .errorMessageRow").show();
                $(".personal-data .j-legal-entity-info + .errorMessageRow").show();
                $(legalEntityInfoSel).children("input, textarea, select").prop("disabled", false);
            } else {
                $(legalEntityInfoSel).hide();
                $(".personal-data .j-company-info + .errorMessageRow").hide();
                $(".personal-data .j-legal-entity-info + .errorMessageRow").hide();
                $(legalEntityInfoSel).children("input, textarea, select").prop("disabled", true);
            }
        });

        if($(entityTypeSel).prop("checked") === true) {
            $(legalEntityInfoSel).show();
            $(".personal-data .j-company-info + .errorMessageRow").show();
            $(".personal-data .j-legal-entity-info + .errorMessageRow").show();
            $(legalEntityInfoSel).children("input, textarea, select").prop("disabled", false);
        } else {
            $(legalEntityInfoSel).hide();
            $(".personal-data .j-company-info + .errorMessageRow").hide();
            $(".personal-data .j-legal-entity-info + .errorMessageRow").hide();
            $(legalEntityInfoSel).children("input, textarea, select").prop("disabled", true);
        }
    };

    return {
        addFocusLossCompanyInput: addFocusLossCompanyInput,
        addLegalEntitySelector: addLegalEntitySelector,
        changeRequiredOnInvoiceCheck: changeRequiredOnInvoiceCheck
    }
}) (jQuery);

$(document).ready(function() {
    InvoiceJs.addFocusLossCompanyInput(".j-company-value", ".j-nin-info", ".j-company-info");
    InvoiceJs.addLegalEntitySelector(".j-legal-entity-selector", ".j-legal-entity-info");
    InvoiceJs.changeRequiredOnInvoiceCheck("#customerInvoiceChecked", "#nin-label")
});